import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgSelectComponent, NgSelectConfig } from '@ng-select/ng-select';
import { forkJoin, Observable } from 'rxjs';
import { Categorias } from 'src/app/core/categorias';
import { Estados } from 'src/app/core/estados';
import { RequestsService } from 'src/app/core/requests.service';
import { CategoriasGptRequest } from 'src/app/core/categoriasGptRequest';
import { FornecedorDto } from 'src/app/core/fornecedordto';
import { SubCategoriasSend } from 'src/app/core/subcategoriassend';
import { CategoriasOut } from 'src/app/core/categoriasout';
import { SubCategorias } from 'src/app/core/subcategorias';
import { Toastr } from 'src/app/core/toastr';
import { TypeMessageEnum } from 'src/app/shared/type-message.enum';
import { Municipios } from 'src/app/core/municipios';
import { Utils } from 'src/app/core/utils/utils';
import {
  ValidateCpfCnpjEmailRequest,
  ValidateCpfCnpjEmailResponse,
} from '../../core/validatecpfcnpjemaildto';
import { FormTwoTransitionCookieData } from '../../core/formTwoTransitionCookieData';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

@Component({
  selector: 'app-index1',
  templateUrl: './index1.component.html',
  styleUrls: ['./index1.component.scss'],
})
export class Index1Component implements OnInit {
  @ViewChild('listSubCategoria') listSubCategoria: NgSelectComponent;
  private readonly transitionCookieName = 'lpFormData';
  private readonly transitionSourceName = 'form-two-paid';
  private hasTrackedCadastroSuccess = false;

  form1: FormGroup;
  form2: FormGroup;
  form3: FormGroup;
  selectedTipoPessoa: string;
  obrigtorioText: string = 'Obrigatório';
  stepSucess: boolean = false;
  redirectCountdown: number = 15;

  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(
    private ngSelectConfig: NgSelectConfig,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private requestService: RequestsService,
    private route: ActivatedRoute,
  ) {
    this.ngSelectConfig.notFoundText = 'Nenhuma informação encontrada.';
    this.form1 = new FormGroup({
      tipoPessoa: new FormControl('juridica'),
      nome: new FormControl(null, [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern(/^[A-Za-zÀ-ÿ\s]*$/),
      ]),
      whatsapp: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{11}$')]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      cnpj: new FormControl(null, [Validators.required, Validators.pattern(/^\d{14}$/)]),
      razaoSocial: new FormControl(null, [Validators.required, Validators.minLength(4)]),
      cpf: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^\d{11}$/),
        Utils.validateCPF,
      ]),
      estado: new FormControl(null, Validators.required),
      municipio: new FormControl({ value: null, disabled: true }, Validators.required),
    });
    this.form2 = new FormGroup({
      oportunidadesBrasil: new FormControl('Apenas meu Estado', Validators.required),
      categoriaFornecimento: new FormControl(null, Validators.required),
      palavraPesquisaGpt: new FormControl({ value: null, disabled: true }),
      subCategoriaFornecimento: new FormControl({ value: [], disabled: true }),
    });
    this.form3 = new FormGroup({
      euSou: new FormControl('Empresario', Validators.required),
      licitante: new FormControl('false', Validators.required),
      interesseCursos: new FormControl('true', Validators.required),
      termos: new FormControl(false, Validators.requiredTrue),
    });
  }

  currentSection = 'home';

  public stepForm = 1;
  estados: Estados[] = [];
  municipiosDTO: Municipios[] = [];
  municipios: string[] = [];
  categorias: Categorias[] = [];
  subCategorias: SubCategorias[] = [];
  categoriasOut: CategoriasOut[] = [];
  gptIsLoading: boolean = false;
  submitIsLoading: boolean = false;
  progressbarValue1: number = 0;
  progressbarValue2: number = 0;
  progressbarValue3: number = 0;
  toastrs: Toastr[] = [];
  toastrsValidate: Toastr[] = [];

  private fornecedorDto: FornecedorDto = {
    razaoSocial: '',
    cnpj: '',
    cpf: '',
    cpfRepresentante: '',
    email: '',
    nome: '',
    telefone: '',
    tipoUsuario: '',
    planoAdesao: null,
    formaPagamento: null,
    termos: null,
    codigoOrigemCadastro: null,
    endereco: {
      cep: '',
      uf: {
        codigoUf: null,
        siglaUf: '',
      },
      municipio: {
        codigo: null,
        nome: '',
      },
      bairro: '',
      endereco: '',
      complemento: '',
      numero: '',
    },
    dadosCampanha: {
      licitante: null,
      receberConteudos: null,
      receberCursos: null,
      receberDicas: null,
      receberJornal: null,
    },
    cookieCampanha: {
      source: '',
      campanha: '',
    },
    ufs: [],
    classesMateriais: [],
  };
  private utmSource = null;
  private utmMedium = null;
  private utmCampaign = null;
  private utmTerm = null;

  updateFormFields() {
    const tipoPessoa = this.form1.get('tipoPessoa').value;
    this.selectedTipoPessoa = tipoPessoa;
    if (tipoPessoa === 'juridica') {
      this.form1
        .get('cnpj')
        .setValidators([Validators.required, Validators.pattern(/^\d{14}$/), Utils.validateCNPJ]);
      this.form1.get('razaoSocial').setValidators([Validators.required, Validators.minLength(4)]);
      this.form1.get('cpf').clearValidators();
      this.form1.get('cpf').setValue('');
    } else {
      this.form1
        .get('cpf')
        .setValidators([Validators.required, Validators.pattern(/^\d{11}$/), Utils.validateCPF]);
      this.form1.get('cnpj').clearValidators();
      this.form1.get('cnpj').setValue('');
      this.form1.get('razaoSocial').clearValidators();
      this.form1.get('razaoSocial').setValue('');
    }
    this.calculateProgressbarValue();
    this.form1.get('cnpj').updateValueAndValidity();
    this.form1.get('razaoSocial').updateValueAndValidity();
    this.form1.get('cpf').updateValueAndValidity();
  }

  hasCNPJError(): boolean {
    const cnpjControl = this.form1.get('cnpj');
    return cnpjControl.hasError('pattern') || cnpjControl.hasError('cnpjInvalid');
  }

  hasCPFError(): boolean {
    const cpfControl = this.form1.get('cpf');
    return cpfControl.hasError('pattern') || cpfControl.hasError('cpfInvalid');
  }

  ngOnInit(): void {
    this.updateFormFields();
    this.requestCategorias();
    this.requestCategoriasOut();
    this.route.queryParams.subscribe((params) => {
      this.utmSource = params['utm_source'];
      this.utmMedium = params['utm_medium'];
      this.utmCampaign = params['utm_campaign'];
      this.utmTerm = params['utm_term'];
    });

    this.loadInitialLocationDataAndTryPrefill();
  }

  private loadInitialLocationDataAndTryPrefill(): void {
    forkJoin({
      estados: this.requestEstados(),
      municipios: this.requestMunicipios(),
    }).subscribe({
      next: ({ estados, municipios }) => {
        this.estados = estados.estados;
        this.municipiosDTO = municipios.municipios;
        this.tryPrefillFromTransitionCookie();
      },
      error: () => {
        console.error('Erro ao carregar dados de localização para pré-preenchimento do formulário.');
      },
    });
  }

  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
      navbar.style.backgroundColor = '#1a1a1a';
      navbar.style.padding = '15px 0px';
    } else {
      navbar.style.backgroundColor = '';
      navbar.style.padding = '20px';
    }
  }

  toggleMenu() {
    document.getElementById('navbarCollapse').classList.toggle('show');
  }

  async onSubmit(): Promise<void> {
    try {
      const canSubmit: boolean = await this.validateCpfCnpjOrEmail();
      if (canSubmit) {
        this.dtoCreate();
        this.requestFornecedorCreate();
      }
    } catch (error) {
      this.toastrs = [];
      this.toastrsValidate = [];
      this.exibeToastr(
        'Erro ao validar os dados. Tente novamente mais tarde.',
        TypeMessageEnum.IMPEDITIVO,
      );
    }
  }

  onNext(form?: NgForm) {
    this.stepForm++;
    this.toastrsValidate = [];
    this.toastrs = [];
    const formHtml = document.getElementById('form');
    formHtml.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onNextFormGroup(form?: FormGroup) {
    this.stepForm++;
    window.scroll(0, 0);
  }

  async handlePesquisarGptClick(): Promise<void> {
    await this.requestGpt();
    this.cdr.detectChanges();
    this.listSubCategoria.open();
  }

  onBackForm(form?: FormGroup): void {
    if (!this.stepSucess) {
      this.stepForm--;
      this.clearToastr(...this.toastrs);
      this.toastrsValidate = [];
      this.toastrs = [];
    }

    if (this.stepSucess) {
      this.stepForm = 3;
      this.stepSucess = false;
    }
  }

  get canAdvance(): boolean {
    if (this.stepForm === 2) return this.form2.valid;
    return false;
  }

  get showButton(): boolean {
    return this.stepForm > 1;
  }

  get advanceIcon(): string {
    return this.canAdvance
      ? './assets/images/arrow-right.svg'
      : './assets/images/arrow-right-disabled.svg';
  }

  async handleGenericSearchClick(): Promise<void> {
    const categoriaSelecionada: Categorias = this.categorias.find(
      (categoria) =>
        categoria.CodigoCategoria == this.form2.get('categoriaFornecimento').value?.CodigoCategoria,
    );
    this.subCategorias = categoriaSelecionada.topicos;
    this.form2.get('subCategoriaFornecimento').enable();
    this.cdr.detectChanges();
    this.listSubCategoria.open();
  }

  handleClick() {
    window.scroll(0, 0);
  }

  requestEstados(): Observable<{ estados: Estados[] }> {
    return this.requestService.getEstados();
  }

  requestMunicipios(): Observable<{ municipios: Municipios[] }> {
    return this.requestService.getMunicipios();
  }

  requestCategorias() {
    this.requestService.getCategorias().subscribe((data: Categorias[]) => {
      this.categorias = data;
    });
  }

  requestCategoriasOut() {
    this.requestService.getCategoriasOut().subscribe((data: CategoriasOut[]) => {
      this.categoriasOut = data;
    });
  }

  navigateToProcessos(): void {
    window.location.href = 'https://www.portaldecompraspublicas.com.br/processos';
  }

  public clearToastr(...toastrToClear: any[]): void {
    this.toastrs = this.toastrs.filter((toastr: any) => {
      return !toastrToClear.includes(toastr);
    });
  }

  private exibeToastr(mensagem: string, status: TypeMessageEnum): void {
    this.clearToastr(...this.toastrs);
    if (this.toastrs.find((toastr) => toastr.mensagem === mensagem)) {
      return;
    }
    this.toastrs.push({
      mensagem,
      status,
    });

    window.scroll(0, 0);
    return;
  }

  private exibeToastrValidate(mensagem: string, status: TypeMessageEnum): void {
    this.clearToastr(...this.toastrsValidate);
    if (this.toastrsValidate.find((toastr) => toastr.mensagem === mensagem)) {
      return;
    }
    this.toastrsValidate.push({
      mensagem,
      status,
    });

    window.scroll(0, 0);
    return;
  }

  onCategoriaChange(selectedCategoria: any) {
    if (selectedCategoria) {
      this.subCategorias = [];
      this.form2.get('palavraPesquisaGpt').enable();
      return;
    }
    this.subCategorias = [];
    this.form2.get('subCategoriaFornecimento').setValue(null);
    this.form2.get('subCategoriaFornecimento').disable();
    this.form2.get('palavraPesquisaGpt').disable();
  }

  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  onGenericFieldChange(): void {
    this.calculateProgressbarValue();
  }

  onEstadoChange(selectedEstado: string) {
    this.calculateProgressbarValue();
    if (selectedEstado != this.form1.get('estado').value) {
      this.form1.get('municipio').setValue(null);
    }
    if (selectedEstado) {
      const estadoSelecionado = this.estados.find((estado) => estado.sigla === selectedEstado);
      this.municipios = estadoSelecionado ? estadoSelecionado.cidades : [];
      this.form1.get('municipio').enable();
      return;
    }
    this.municipios = [];
    this.form1.get('municipio').setValue(null);
    this.form1.get('municipio').disable();
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      if (this.form2.get('palavraPesquisaGpt').value?.length >= 4) {
        this.handlePesquisarGptClick();
      }
      event.preventDefault();
    }
  }

  scrollToSection(id: string, event: Event): void {
    event.preventDefault();
    const element: HTMLElement | null = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      this.currentSection = id;
    }
  }

  private calculateProgressbarValue(): void {
    this.progressbarValue1 = this.calculateFormProgress(this.form1);
    this.progressbarValue2 = this.calculateFormProgress(this.form2);
    this.progressbarValue3 = this.calculateFormProgress(this.form3);
  }

  private calculateFormProgress(formGroup): number {
    const tipoPessoa = this.form1.get('tipoPessoa').value === 'juridica';

    const formControls = [
      'nome',
      'whatsapp',
      'email',
      'estado',
      'municipio',
      'oportunidadesBrasil',
      'categoriaFornecimento',
      'subCategoriaFornecimento',
      'euSou',
      'licitante',
      'interesseCursos',
      'termos',
    ];

    const tipoPessoaFields = tipoPessoa ? ['razaoSocial', 'cnpj'] : ['cpf'];
    const allFields = [...formControls, ...tipoPessoaFields];

    const totalFieldsInForm = allFields.filter((controlName) => formGroup.controls[controlName]);
    const valuePerControl = 100 / totalFieldsInForm.length;

    let progressValue = 0;
    totalFieldsInForm.forEach((controlName) => {
      const control = formGroup.controls[controlName];
      if (control && control.value != null && control.value !== '' && !control.disabled) {
        progressValue += valuePerControl;
      }
    });

    return Math.round(progressValue);
  }

  private categoriasOutCreate(): SubCategoriasSend[] {
    const categoriasSelected: SubCategorias[] = this.form2.get('subCategoriaFornecimento').value;
    const subCategoriasSelectedCodes = categoriasSelected.map(
      (subCategoria) => subCategoria.codigoCategoria,
    );
    const subCategoriasSend: SubCategoriasSend[] = this.categoriasOut.reduce(
      (acc: SubCategoriasSend[], categoria: CategoriasOut) => {
        const topicosToSend = categoria.topicos
          .filter((topico) => subCategoriasSelectedCodes.includes(String(topico.codigo)))
          .map((topico) => {
            return {
              codigo: topico.codigo,
              grupoMaterial: {
                codigo: categoria.codigo,
              },
            };
          });

        return [...acc, ...topicosToSend];
      },
      [],
    );

    return subCategoriasSend;
  }

  private dtoCreate() {
    this.fornecedorDto.razaoSocial = this.form1.get('razaoSocial').value;
    this.fornecedorDto.cnpj = this.form1.get('cnpj').value;
    this.fornecedorDto.cpf = this.form1.get('cpf').value;
    this.fornecedorDto.email = this.form1.get('email').value;
    this.fornecedorDto.nome = this.form1.get('nome').value;
    this.fornecedorDto.telefone = this.form1.get('whatsapp').value;
    this.fornecedorDto.tipoUsuario = 'Fornecedor';
    this.fornecedorDto.planoAdesao = 0;
    this.fornecedorDto.formaPagamento = 0;
    this.fornecedorDto.termos = true;
    this.fornecedorDto.codigoOrigemCadastro = 13;
    this.fornecedorDto.endereco.uf.codigoUf = this.form1.get('estado').value.codigo;
    this.fornecedorDto.endereco.uf.siglaUf = this.form1.get('estado').value.sigla;
    this.fornecedorDto.endereco.municipio.nome = this.form1.get('municipio').value;
    const nomeMunicipio = this.fornecedorDto.endereco.municipio.nome;
    this.fornecedorDto.endereco.municipio.codigo = this.municipiosDTO.find(
      (municipio) => municipio.NOME_MUNICIPIO === nomeMunicipio,
    ).CD_MUNICIPIO;
    this.fornecedorDto.dadosCampanha.licitante = Boolean(this.form3.get('licitante').value);
    this.fornecedorDto.dadosCampanha.receberConteudos = Boolean(
      this.form3.get('interesseCursos').value,
    );
    this.fornecedorDto.dadosCampanha.receberCursos = Boolean(
      this.form3.get('interesseCursos').value,
    );
    this.fornecedorDto.dadosCampanha.receberDicas = Boolean(
      this.form3.get('interesseCursos').value,
    );
    this.fornecedorDto.dadosCampanha.receberJornal = true;
    this.fornecedorDto.cookieCampanha.source = Array.isArray(this.utmSource)
      ? String(this.utmSource[0] ?? '')
      : String(this.utmSource ?? '');
    this.fornecedorDto.cookieCampanha.campanha = Array.isArray(this.utmCampaign)
      ? String(this.utmCampaign[0] ?? '')
      : String(this.utmCampaign ?? '');

    if (this.form2.get('oportunidadesBrasil').value == 'Apenas meu Estado') {
      this.fornecedorDto.ufs = [];
      this.fornecedorDto.ufs.push(this.fornecedorDto.endereco.uf.codigoUf);
    } else {
      this.fornecedorDto.ufs = [];
      this.estados.forEach((estado) => this.fornecedorDto.ufs.push(estado.codigo));
    }
    this.fornecedorDto.ufs.push(
      this.form2.get('oportunidadesBrasil').value == 'Apenas meu Estado'
        ? this.fornecedorDto.endereco.uf.codigoUf
        : 0,
    );
    this.fornecedorDto.classesMateriais = this.categoriasOutCreate();
  }

  private requestFornecedorCreate(): Promise<void> {
    this.submitIsLoading = true;
    return new Promise((resolve, reject) => {
      this.requestService.postCadastro(this.fornecedorDto).subscribe(
        (data: any) => {
          this.submitIsLoading = false;
          window.scroll(0, 0);
          this.stepSucess = true;
          this.trackCadastroSuccess();
          this.startRedirectCountdown();
          this.toastrs = [];
          resolve();
        },
        async (error) => {
          try {
            const message =
              error?.error?.message ??
              'Erro inesperado ao tentar cadastrar. Por favor, tente novamente mais tarde.';

            const messageTranslated = this.messageErrorTranslate(error.error?.message ?? message);
            this.exibeToastr(messageTranslated, TypeMessageEnum.IMPEDITIVO);
          } catch (err) {
            console.error('Erro no bloco catch interno:', err);
          } finally {
            this.submitIsLoading = false;
            this.stepSucess = false;
            reject(error);
          }
        },
      );
    });
  }

  private trackCadastroSuccess(): void {
    if (this.hasTrackedCadastroSuccess || !globalThis.window) {
      return;
    }

    this.hasTrackedCadastroSuccess = true;
    globalThis.window.dataLayer = globalThis.window.dataLayer || [];
    globalThis.window.dataLayer.push({
      event: 'cadastro_sucesso',
      fluxo: 'cadastro_simplificado',
      tag: '[FORN] Assinatura do Alerta',
    });
  }

  private requestGpt(): Promise<void> {
    this.gptIsLoading = true;

    const categoriaSelecionada: Categorias = this.categorias.find(
      (categoria) =>
        categoria.CodigoCategoria == this.form2.get('categoriaFornecimento').value?.CodigoCategoria,
    );

    const categoriaGptRequest: CategoriasGptRequest = {
      codigo: categoriaSelecionada.CodigoCategoria,
      nome: categoriaSelecionada.nomeGrupo,
      palavra: this.form2.get('palavraPesquisaGpt').value,
      topicos: categoriaSelecionada.topicos.map((item) => ({
        codigo: item.codigoCategoria,
        nome: item.codigoMaterial,
      })),
    };

    return new Promise((resolve, reject) => {
      this.requestService.getCategoriasGpt(categoriaGptRequest).subscribe(
        (data: any) => {
          if (data.data.length == 0) {
            const categoriaSelecionada: Categorias = this.categorias.find(
              (categoria) =>
                categoria.CodigoCategoria ==
                this.form2.get('categoriaFornecimento').value?.CodigoCategoria,
            );
            this.subCategorias = categoriaSelecionada.topicos;
          } else {
            const codigosRetorno: number[] = data.data;
            const newSubCategorias = codigosRetorno.map((codigo) =>
              categoriaGptRequest.topicos.find(
                (subCategoria) => subCategoria.codigo == String(codigo),
              ),
            );
            this.subCategorias = newSubCategorias.map((item) => ({
              codigoCategoria: item.codigo,
              codigoMaterial: item.nome,
            }));
          }
          this.form2.get('subCategoriaFornecimento').enable();
          setTimeout(() => {
            this.gptIsLoading = false;
          }, 1000);
          resolve();
        },
        (error) => {
          this.subCategorias = categoriaSelecionada.topicos;
          this.form2.get('subCategoriaFornecimento').enable();
          setTimeout(() => {
            this.gptIsLoading = false;
          }, 1000);
          reject();
        },
      );
    });
  }

  private messageErrorTranslate(messageErrorReceived: string): string {
    const document: string = this.form1.get('tipoPessoa').value === 'fisica' ? 'CPF' : 'CNPJ';
    switch (messageErrorReceived) {
      case 'Business Layer: Já existe cadastro para o documento informado, favor verificar. Clique aqui caso tenha esquecido sua senha.':
        return `Já existe cadastro vinculado a este ${document}. Caso não se lembre, entre em contato com a nossa Central 3003-5455.`;

      case 'Business Layer: O email escolhido por você já esta sendo utilizado no Portal, favor tentar outro login.':
        return 'O e-mail inserido já está cadastrado no Portal, por favor tente cadastrar outro e-mail.';

      default:
        return 'Erro ao cadastrar dados. <br>Por favor, verifique os campos preenchidos e em caso de persistência, entre em contato com a nossa Central 3003-5455.';
    }
  }

  validateCpfCnpjOrEmail(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const params: ValidateCpfCnpjEmailRequest = {
        cpf: this.form1.get('cpf').value,
        cnpj: this.form1.get('cnpj').value,
        email: this.form1.get('email').value,
        tipoCadastro: 'AdesaoFornecedor',
      };

      this.submitIsLoading = true;
      this.requestService.getValidateCpfCnpjOrEmail(params).subscribe({
        next: (response: ValidateCpfCnpjEmailResponse) => {
          if (response.cnpj || response.email) {
            this.stepForm = 1;
            this.exibeToastrValidate(
              'Já existe um usuário cadastrado com esses dados.<a class="style-login" href="https://operacao.portaldecompraspublicas.com.br/18/loginext/" target="_blank"> Faça login ou recupere sua senha aqui.</a>',
              TypeMessageEnum.IMPEDITIVO,
            );
            resolve(false);
            this.submitIsLoading = false;
          } else {
            resolve(true);
            this.toastrsValidate = [];
            this.submitIsLoading = true;
          }
        },
        error: (error) => {
          console.error('Validation error:', error);
          this.submitIsLoading = false;
          reject(error);
        },
      });
    });
  }

  private startRedirectCountdown(): void {
    if (this.intervalId !== null) return;

    this.intervalId = setInterval(() => {
      if (this.redirectCountdown > 0) {
        this.redirectCountdown--;
      } else {
        clearInterval(this.intervalId!);
        this.intervalId = null;
        this.navigateToProcessos();
      }
    }, 1000);
  }

  private tryPrefillFromTransitionCookie(): void {
    const source = this.route.snapshot.queryParamMap.get('source');
    if (source && source !== this.transitionSourceName) {
      return;
    }

    const transitionData = this.readTransitionCookie();
    if (!transitionData) {
      return;
    }

    if (!this.estados.length || !this.municipiosDTO.length) {
      return;
    }

    this.applyTransitionDataToForm(transitionData);
    this.clearTransitionCookie();
  }

  private readTransitionCookie(): FormTwoTransitionCookieData | null {
    const cookies = document.cookie?.split(';') ?? [];
    const prefix = `${this.transitionCookieName}=`;
    const transitionCookie = cookies.find((cookie) => cookie.trim().startsWith(prefix));

    if (!transitionCookie) {
      return null;
    }

    try {
      const cookieValue = decodeURIComponent(transitionCookie.trim().substring(prefix.length));
      return JSON.parse(cookieValue) as FormTwoTransitionCookieData;
    } catch (error) {
      console.warn('Cookie de transição inválido para pré-preenchimento.', error);
      return null;
    }
  }

  private clearTransitionCookie(): void {
    document.cookie = `${this.transitionCookieName}=; max-age=0; path=/; domain=.portaldecompraspublicas.com.br`;
    document.cookie = `${this.transitionCookieName}=; max-age=0; path=/`;
  }

  private applyTransitionDataToForm(data: FormTwoTransitionCookieData): void {
    this.applyPessoaData(data);
    this.applyForm1Data(data);

    this.calculateProgressbarValue();

    // Mantem o usuario na etapa 1 para validacao manual dos dados pre-preenchidos.
    this.stepForm = 1;
  }

  private applyPessoaData(data: FormTwoTransitionCookieData): void {
    let tipoPessoa: 'juridica' | 'fisica' = 'juridica';
    const hasCnpj = !!this.firstNonEmptyString(data.cnpj, data.cnpjValue);
    const hasCpf = !!this.firstNonEmptyString(data.cpf, data.cpfValue);

    if (data.tipoPessoa === 'fisica' || data.isPessoaFisica) {
      tipoPessoa = 'fisica';
    }

    if (data.tipoPessoa === 'juridica' || data.isPessoaJuridica || hasCnpj) {
      tipoPessoa = 'juridica';
    }

    if (!data.tipoPessoa && !data.isPessoaFisica && !data.isPessoaJuridica && hasCpf && !hasCnpj) {
      tipoPessoa = 'fisica';
    }

    this.form1.patchValue({ tipoPessoa });
    this.updateFormFields();
  }

  private applyForm1Data(data: FormTwoTransitionCookieData): void {
    const estadoSelecionado = this.resolveEstado(data);
    const municipioRaw = this.firstNonEmptyString(
      data.municipio,
      data.selectedMunicipio,
      data.municipioNome,
      data.cidade,
    );
    const tipoPessoa = this.form1.get('tipoPessoa').value;

    const nome = this.firstNonEmptyString(data.nome, data.representanteLegal, data.representanteLegalValue);
    const email = this.firstNonEmptyString(data.email, data.emailValue);
    const whatsapp = this.normalizeDigits(
      this.firstNonEmptyString(data.celular, data.celularValue, data.whatsapp),
      11,
    );
    const cnpj = this.normalizeDigits(this.firstNonEmptyString(data.cnpj, data.cnpjValue), 14);
    const cpf = this.normalizeDigits(this.firstNonEmptyString(data.cpf, data.cpfValue), 11);
    const razaoSocial = this.firstNonEmptyString(data.razaoSocial, data.razaoSocialValue);

    this.form1.patchValue({
      nome,
      email,
      whatsapp,
      cnpj,
      cpf,
      razaoSocial,
      estado: estadoSelecionado,
    });

    if (tipoPessoa === 'fisica' && !cpf && cnpj) {
      this.form1.patchValue({ cpf: null });
    }

    if (estadoSelecionado) {
      this.onEstadoChange(estadoSelecionado.sigla);
    }

    if (municipioRaw) {
      const municipioNome = this.findMunicipioByName(municipioRaw) ?? municipioRaw;
      this.form1.patchValue({ municipio: municipioNome });
    }
  }

  private findMunicipioByName(municipioNome: string | null): string | null {
    if (!municipioNome) {
      return null;
    }

    const normalizedTarget = this.normalizeText(municipioNome);

    const municipioMatch = this.municipios.find(
      (municipioItem) => this.normalizeText(municipioItem) === normalizedTarget,
    );

    return municipioMatch ?? null;
  }

  private normalizeText(value: string): string {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  private resolveEstado(data: FormTwoTransitionCookieData): Estados | null {
    const selectedUf = data.selectedUf;
    const estadoCandidates = [
      this.firstNonEmptyString(data.uf, data.estado),
      typeof selectedUf === 'string' ? selectedUf : selectedUf?.value,
      typeof selectedUf === 'string' ? null : selectedUf?.sigla,
      typeof selectedUf === 'string' ? null : selectedUf?.nome,
      typeof selectedUf === 'string' ? null : selectedUf?.codigo?.toString(),
    ].filter((item): item is string => !!item);

    for (const candidate of estadoCandidates) {
      const normalizedCandidate = candidate.trim().toUpperCase();
      const bySigla = this.estados.find((estado) => estado.sigla.toUpperCase() === normalizedCandidate);
      if (bySigla) {
        return bySigla;
      }

      const byNome = this.estados.find((estado) => estado.nome.toUpperCase() === normalizedCandidate);
      if (byNome) {
        return byNome;
      }

      if (/^\d+$/.test(normalizedCandidate)) {
        const byCodigo = this.estados.find((estado) => estado.codigo === Number(normalizedCandidate));
        if (byCodigo) {
          return byCodigo;
        }
      }
    }

    return null;
  }

  private firstNonEmptyString(...values: (string | undefined | null)[]): string | null {
    const firstValue = values.find((value) => value?.toString().trim());
    return firstValue?.toString().trim() || null;
  }

  private normalizeDigits(value?: string, length?: number): string | null {
    if (!value) {
      return null;
    }

    const digits = value.replace(/\D/g, '');
    if (!digits) {
      return null;
    }

    if (!length) {
      return digits;
    }

    if (digits.length >= length) {
      return digits.slice(0, length);
    }

    return digits;
  }
}
